<template>
  <div class="gt-overlay">
    <!-- TOP HEADER -->
    <div class="gt-header">
      <div class="gt-header-left"><i class="fa fa-gamepad"></i> GAME MODE</div>
      <div class="gt-header-right" style="margin-left: auto">
        <el-button v-if="session.zoom?.id" size="small" class="theme flex_c" @click="handleZoomClick">
          <div class="flex_c">
            <img src="../../../assets/meetings.png" class="flex_c" style="height: 1.2rem" />
            <div style="margin-left: 5px">Meeting</div>
          </div>
        </el-button>
      </div>
    </div>

    <div class="gt-main" :class="{'gt-mobile-dashboard': isDashboard}">
      <!-- LEFT PANEL -->
      <div class="gt-left-panel">
        <!-- MOBILE-ONLY: Projector Tabs -->
        <div v-if="!isDashboard" class="gt-projector-tabs">
          <div class="gt-pt-tab" :class="{active: activeProjectorMobileTab === 'race'}" @click="activeProjectorMobileTab = 'race'">Live Race</div>
          <div class="gt-pt-tab" :class="{active: activeProjectorMobileTab === 'leaderboard'}" @click="activeProjectorMobileTab = 'leaderboard'">
            Leaderboard
          </div>
        </div>

        <!-- MOBILE-ONLY: Dashboard Tabs -->
        <div v-if="isDashboard" class="gt-projector-tabs gt-dashboard-tabs">
          <div class="gt-pt-tab" :class="{active: activeDashboardMobileTab === 'analytics'}" @click="activeDashboardMobileTab = 'analytics'">
            Live Analytics
          </div>
          <div class="gt-pt-tab" :class="{active: activeDashboardMobileTab === 'leaderboard'}" @click="activeDashboardMobileTab = 'leaderboard'">
            Leader Board
          </div>
          <div class="gt-pt-tab" :class="{active: activeDashboardMobileTab === 'logs'}" @click="activeDashboardMobileTab = 'logs'">Activity LOG</div>
        </div>

        <div class="gt-timer-box">
          <div class="gt-timer-label">TIME REMAINING</div>
          <div class="gt-timer-value">{{ formatTime(timeRemaining) }}</div>
          <div class="gt-timer-bar-container"><div class="gt-timer-bar" :style="{width: (timeRemaining / totalTime) * 100 + '%'}"></div></div>
        </div>

        <!-- MOBILE-ONLY: Race Track between timer and leaderboard -->
        <div v-if="!isDashboard" class="gt-mobile-race" :class="{'gt-hide-on-mobile': activeProjectorMobileTab !== 'race'}">
          <div class="gt-section-title" style="margin-top: 8px">LIVE RACE STATUS</div>
          <div class="gt-mobile-race-labels">
            <div v-for="team in sortedTeams" :key="'ml-' + team.id" class="gt-mobile-race-label">
              <div class="gt-mobile-race-name" :style="{color: team.color}">{{ team.name.replace('TEAM ', '') }}</div>
              <div class="gt-mobile-race-pct" :style="{color: team.color}">{{ Math.round(team.progress || 0) }}%</div>
            </div>
          </div>
          <div class="gt-race-track gt-mobile-race-track">
            <div v-for="team in sortedTeams" :key="'mr-' + team.id" class="gt-rocket-lane">
              <div
                class="gt-rocket-wrapper"
                :class="{'rocket-moving': movingTeams.has(team.id), 'rocket-finished': team.progress >= 100}"
                :style="{bottom: getRocketBottom(team.progress) + '%'}">
                <div class="gt-rocket-label" :style="{borderColor: team.color, color: team.color}">
                  {{ team.name.replace('TEAM', 'Team') }} • {{ team.score || 0 }}
                  <div v-if="teamScorePopups[team.id]" class="gt-score-popup">+2</div>
                </div>
                <div class="gt-rocket-icon" :style="{color: team.color}">
                  <svg class="rocket-svg" viewBox="0 0 680 580" xmlns="http://www.w3.org/2000/svg">
                    <defs>
                      <radialGradient :id="'mg1-' + team.id" cx="50%" cy="88%" r="70%" spreadMethod="pad">
                        <stop offset="0%" stop-color="#FFFFFF" />
                        <stop offset="10%" stop-color="#E0FFFF" />
                        <stop offset="30%" stop-color="#00FFFF" />
                        <stop offset="55%" stop-color="#0088FF" />
                        <stop offset="85%" stop-color="#0033CC" />
                        <stop offset="100%" stop-color="#001A66" stop-opacity="0" />
                      </radialGradient>
                      <filter :id="'m-hyper-glow-' + team.id">
                        <feGaussianBlur stdDeviation="3.5" result="coloredBlur" />
                        <feMerge>
                          <feMergeNode in="coloredBlur" />
                          <feMergeNode in="SourceGraphic" />
                        </feMerge>
                      </filter>
                      <radialGradient :id="'mg2-' + team.id" cx="50%" cy="90%" r="60%">
                        <stop offset="0%" stop-color="#FFFFFF" />
                        <stop offset="15%" stop-color="#CCFFFF" />
                        <stop offset="45%" stop-color="#00DDFF" />
                        <stop offset="80%" stop-color="#0055FF" />
                        <stop offset="100%" stop-color="#0022AA" stop-opacity="0" />
                      </radialGradient>
                      <radialGradient :id="'mg3-' + team.id" cx="50%" cy="92%" r="46%">
                        <stop offset="0%" stop-color="#FFFFFF" />
                        <stop offset="12%" stop-color="#E0FFFF" />
                        <stop offset="55%" stop-color="#00CCFF" />
                        <stop offset="100%" stop-color="#0066FF" stop-opacity="0" />
                      </radialGradient>
                      <radialGradient :id="'mg4-' + team.id" cx="50%" cy="95%" r="40%">
                        <stop offset="0%" stop-color="#FFFFFF" />
                        <stop offset="30%" stop-color="#CCFFFF" />
                        <stop offset="100%" stop-color="#00EEFF" stop-opacity="0" />
                      </radialGradient>
                      <radialGradient :id="'mglow1-' + team.id" cx="50%" cy="72%" r="65%">
                        <stop offset="0%" stop-color="#00FFFF" stop-opacity=".92" />
                        <stop offset="50%" stop-color="#0088FF" stop-opacity=".52" />
                        <stop offset="100%" stop-color="#0033CC" stop-opacity="0" />
                      </radialGradient>
                      <radialGradient :id="'mglow2-' + team.id" cx="50%" cy="68%" r="78%">
                        <stop offset="0%" stop-color="#00CCFF" stop-opacity=".42" />
                        <stop offset="100%" stop-color="#0022AA" stop-opacity="0" />
                      </radialGradient>
                    </defs>
                    <g class="rg">
                      <image :href="rocketImgSrc" x="60" y="-20" width="560" height="370" />
                      <ellipse cx="340" cy="328" rx="70" ry="24" :fill="'url(#mglow2-' + team.id + ')'" class="gl" />
                      <ellipse cx="340" cy="315" rx="50" ry="17" :fill="'url(#mglow1-' + team.id + ')'" class="gl" />
                      <g>
                        <g class="l1">
                          <path
                            d="M298 298 Q314 368 340 500 Q366 368 382 298 Q364 322 340 327 Q316 322 298 298Z"
                            :fill="'url(#mg1-' + team.id + ')'"
                            :filter="'url(#m-hyper-glow-' + team.id + ')'" />
                        </g>
                        <g class="l2">
                          <path
                            d="M306 298 Q320 358 340 480 Q360 358 374 298 Q360 318 340 323 Q320 318 306 298Z"
                            :fill="'url(#mg2-' + team.id + ')'"
                            :filter="'url(#m-hyper-glow-' + team.id + ')'" />
                        </g>
                        <g class="l3">
                          <path
                            d="M314 299 Q326 345 340 450 Q354 345 366 299 Q355 316 340 320 Q325 316 314 299Z"
                            :fill="'url(#mg3-' + team.id + ')'"
                            :filter="'url(#m-hyper-glow-' + team.id + ')'" />
                        </g>
                        <g class="l4">
                          <path
                            d="M321 300 Q332 335 340 420 Q348 335 359 300 Q351 313 340 316 Q329 313 321 300Z"
                            :fill="'url(#mg4-' + team.id + ')'"
                            :filter="'url(#m-hyper-glow-' + team.id + ')'" />
                        </g>
                        <path d="M331 300 Q336 324 340 390 Q344 324 349 300 Q345 309 340 311 Q335 309 331 300Z" fill="white" opacity=".96" />
                        <g class="l2">
                          <path d="M306 298 Q320 358 340 412 Q360 358 374 298 Q360 318 340 323 Q320 318 306 298Z" :fill="'url(#mg2-' + team.id + ')'" />
                        </g>
                        <g class="l3">
                          <path d="M314 299 Q326 345 340 388 Q354 345 366 299 Q355 316 340 320 Q325 316 314 299Z" :fill="'url(#mg3-' + team.id + ')'" />
                        </g>
                        <g class="l4">
                          <path d="M321 300 Q332 335 340 364 Q348 335 359 300 Q351 313 340 316 Q329 313 321 300Z" :fill="'url(#mg4-' + team.id + ')'" />
                        </g>
                        <path d="M331 300 Q336 324 340 346 Q344 324 349 300 Q345 309 340 311 Q335 309 331 300Z" fill="white" opacity=".96" />
                        <ellipse cx="340" cy="302" rx="7" ry="4" fill="#00FFFF" class="s1" />
                        <ellipse cx="340" cy="302" rx="5" ry="3" fill="#0088FF" class="s2" />
                        <circle cx="340" cy="302" r="4" fill="#CCFFFF" class="s3" />
                        <circle cx="340" cy="302" r="3.5" fill="#0055FF" class="s4" />
                        <ellipse cx="340" cy="302" rx="5" ry="3" fill="#00DDFF" class="s5" />
                        <circle cx="340" cy="302" r="3" fill="#0099FF" class="s6" />
                        <circle cx="340" cy="302" r="5" fill="#00EEFF" class="s7" />
                        <ellipse cx="340" cy="302" rx="6" ry="3.5" fill="#0066FF" class="s8" />
                        <circle cx="340" cy="302" r="3" fill="#00BBFF" class="s9" />
                        <ellipse cx="340" cy="302" rx="4" ry="2.5" fill="#00FFEE" class="s10" />
                        <ellipse cx="340" cy="302" rx="9" ry="5" fill="#0099FF" opacity=".44" class="w1" />
                        <ellipse cx="340" cy="302" rx="7" ry="4" fill="#0077FF" opacity=".36" class="w2" />
                        <ellipse cx="340" cy="302" rx="6" ry="3.5" fill="#00DDFF" opacity=".4" class="w3" />
                        <ellipse cx="340" cy="302" rx="8" ry="4.5" fill="#0055FF" opacity=".28" class="w4" />
                      </g>
                    </g>
                  </svg>
                  <div class="gt-rocket-tail" :style="{background: `linear-gradient(to bottom, ${team.color}, transparent)`}"></div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          class="gt-section-title"
          :class="{
            'gt-hide-on-mobile': (!isDashboard && activeProjectorMobileTab !== 'leaderboard') || (isDashboard && activeDashboardMobileTab !== 'leaderboard'),
          }">
          LIVE LEADERBOARD
        </div>
        <div
          class="gt-leaderboard"
          :class="{
            'gt-hide-on-mobile': (!isDashboard && activeProjectorMobileTab !== 'leaderboard') || (isDashboard && activeDashboardMobileTab !== 'leaderboard'),
          }">
          <div v-for="(team, index) in sortedTeams" :key="team.id" class="gt-lb-card" :style="{borderColor: team.color}">
            <div class="gt-lb-rank" :style="{color: team.color}">{{ String(index + 1).padStart(2, '0') }}</div>
            <div class="gt-lb-info">
              <div class="gt-lb-name">{{ team.name }}</div>
              <div class="gt-lb-avatars">
                <div
                  v-for="member in team.members.slice(0, 3)"
                  :key="member.id"
                  class="gt-avatar"
                  :style="{backgroundColor: getContrastColor(member.colorIndex)}">
                  <img v-if="member.avatar" :src="member.avatar" style="width: 100%; height: 100%; border-radius: 50%; object-fit: cover" />
                  <span v-else>{{ getInitials(member.name) }}</span>
                </div>
                <div v-if="team.members.length > 3" class="gt-avatar gt-more" style="background-color: #0d2729; color: #00ffff">
                  +{{ team.members.length - 3 }}
                </div>
              </div>
            </div>
            <div class="gt-lb-score">
              <div class="gt-lb-points" :style="{color: team.color}">{{ team.score || 0 }}</div>
              <div class="gt-lb-points-label">POINTS</div>
            </div>
          </div>
        </div>

        <div v-if="isDashboard && latestActivity?.length" class="gt-recent-activity" :class="{'gt-hide-on-mobile': activeDashboardMobileTab !== 'leaderboard'}">
          <div class="gt-recent-header" style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 14px">
            <span style="font-size: 10px; color: #8c99a0; font-weight: bold; letter-spacing: 1px">RECENT ACTIVITY</span>
            <span style="font-size: 10px; color: #00ffff">Live Now</span>
          </div>
          <div class="gt-recent-content" style="display: flex; align-items: center; color: #fff; font-size: 12px">
            <i class="fa fa-check-circle-o" style="color: #00ffff; font-size: 16px; margin-right: 8px"></i>
            <span v-html="latestActivity"></span>
          </div>
        </div>

        <button class="gt-btn-end" @click="endGame(true)">END GAME</button>
      </div>

      <!-- CENTER PANEL: SLIDE VIEWER (dashboard) or ROCKET RACE -->
      <div class="gt-center-panel" :class="{'gt-center-slides': isDashboard, 'gt-hide-on-mobile': isDashboard && activeDashboardMobileTab !== 'analytics'}">
        <!-- DASHBOARD: SLIDE GRID VIEWER -->
        <template v-if="isDashboard">
          <div style="flex: 1; overflow-y: auto; width: 100%; box-sizing: border-box" :style="{paddingTop: isDashboard ? '4px' : '20px'}">
            <div class="gt-hide-on-mobile" style="margin-bottom: 24px; padding: 0px 14px">
              <div style="font-size: 36px; font-weight: 800; color: #fff; letter-spacing: 1px; display: flex; align-items: baseline; gap: 8px">
                LIVE <span style="color: #00ffff; border-bottom: 4px solid #00ffff; padding-bottom: 2px">ANALYTICS</span>
              </div>
              <div style="color: #00b3b3; font-size: 14px; font-weight: bold; margin-top: 12px">Question Performance Overview & Student Engagement Metrics</div>
            </div>
            <div class="gt-dashboard-grid" style="overflow-y: visible; height: auto; padding: 0 14px">
              <div
                v-for="(slide, idx) in gameConfig.slides"
                :key="slide.id || idx"
                class="gt-dashboard-card"
                :class="{'gt-mobile-expanded': expandedDashboardCards[idx]}"
                :style="{zIndex: activeTooltipSlideId === (slide.page || slide.id) ? 100 : 1}">
                <div class="gt-dashboard-card-header" style="position: relative">
                  <span style="color: #00ffff; font-weight: bold; font-size: 14px">Question {{ idx + 1 }}</span>
                  <div class="gt-view-btn gt-hide-on-mobile" @click.stop="isCpaQuestion(slide) ? previewCpa(slide) : previewImage(slide.pic)">
                    <i class="fa fa-eye"></i> VIEW
                  </div>
                  <div
                    class="gt-view-btn gt-show-on-mobile-flex"
                    @click.stop="toggleDashboardCard(idx)"
                    style="display: none; width: 24px; justify-content: center; background: rgba(0, 255, 255, 0.1); padding: 4px; border-radius: 4px">
                    <i class="fa" :class="expandedDashboardCards[idx] ? 'fa-caret-up' : 'fa-caret-down'"></i>
                  </div>

                  <!-- CPA Tooltip -->
                  <div
                    v-if="isCpaQuestion(slide) && activeTooltipSlideId === (slide.page || slide.id)"
                    class="gs-cpa-tooltip gt-hide-on-mobile"
                    :class="{'gs-cpa-tooltip-left': idx % 2 === 0, 'gs-cpa-tooltip-right': idx % 2 !== 0}"
                    @click.stop>
                    <div class="gs-cpa-tooltip-question" v-html="previewCpaData ? previewCpaData.abstractData : ''"></div>
                    <div class="gs-cpa-tooltip-options">
                      <div v-for="(opt, oIdx) in previewCpaData ? previewCpaData.options : []" :key="oIdx" class="gs-cpa-tooltip-option">
                        <i v-if="opt.on" class="fa fa-check gs-cpa-tooltip-tick"></i>
                        <span :class="{'gs-cpa-tooltip-indent': !opt.on}">{{ opt.val }}</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="gt-dashboard-card-body" style="flex: 1; padding: 12px; overflow-y: hidden; display: flex; flex-direction: column; gap: 10px">
                  <!-- Image if normal slide -->
                  <div
                    v-if="slide.pic && !isCpaQuestion(slide)"
                    class="gt-slide-image"
                    :style="{
                      backgroundImage: 'url(' + Fn.hashToUrl(slide.pic) + ')',
                      minHeight: '150px',
                      backgroundSize: 'contain',
                      backgroundRepeat: 'no-repeat',
                      backgroundPosition: 'center',
                    }"></div>

                  <!-- CPA Question Details -->
                  <template v-if="isCpaQuestion(slide)">
                    <div class="gt-cpa-question-text">
                      {{ getQuestionText(slide) }}
                    </div>
                    <!-- CPA Options (Mobile Only) -->
                    <div class="gt-cpa-mobile-options gt-show-on-mobile-flex" style="display: none; flex-direction: column; gap: 4px; margin-top: 0">
                      <div
                        v-for="(opt, oIdx) in getSlideOptions(slide)"
                        :key="oIdx"
                        style="display: flex; align-items: flex-start; font-size: 14px !important; line-height: 1.3">
                        <i v-if="opt.on" class="fa fa-check" style="color: #00e676; margin-right: 8px; margin-top: 2px; width: 14px; text-align: center"></i>
                        <span :style="{marginLeft: !opt.on ? '22px' : '0', fontSize: 'inherit'}">{{ opt.val || opt.data || opt.text || opt }}</span>
                      </div>
                    </div>
                    <!-- Bloom Analytics Table -->
                    <div class="gt-bloom-table-container">
                      <div class="gt-bloom-table">
                        <div class="gt-bloom-header">
                          <div style="flex: 2; padding-left: 12px">BLOOM LEVEL</div>
                          <div style="flex: 1; text-align: center">ATTEMPT</div>
                          <div style="flex: 1; text-align: center">CORRECT</div>
                          <div style="flex: 1; text-align: center">WRONG</div>
                        </div>
                        <div class="gt-bloom-rows">
                          <div v-for="(stat, sIdx) in getCpaBloomStats(slide)" :key="sIdx" class="gt-bloom-row">
                            <div style="flex: 2; font-size: 10px !important; font-weight: bold; color: #fff; letter-spacing: 1.5px">
                              {{ stat.levelPrefix }}<span style="color: #00ffff; font-size: inherit !important">{{ stat.levelName }}</span>
                            </div>
                            <div style="flex: 1; text-align: center; font-size: 11px !important; font-weight: normal; color: #e2e8f0">{{ stat.attempt }}</div>
                            <div style="flex: 1; text-align: center; color: #22c55e; font-size: 11px !important; font-weight: normal">{{ stat.correct }}</div>
                            <div style="flex: 1; text-align: center; color: #ef4444; font-size: 11px !important; font-weight: normal">{{ stat.wrong }}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>
                </div>

                <!-- Show Demo Button -->
                <div class="gt-dashboard-card-footer">
                  <div style="display: flex; gap: 8px; align-items: baseline">
                    <span style="color: #c9d1d6; font-size: 11px">{{ getPercentAttempted(slide) }}% Attempted</span>
                    <span style="color: #00ff88; font-size: 11px; font-weight: bold">{{ getPercentCorrect(slide) }}% Correct</span>
                  </div>
                  <button
                    class="gt-btn-demo"
                    @click="openCpaDemo(slide)"
                    style="
                      background: #00ffff;
                      color: #000;
                      border: none;
                      padding: 8px 16px;
                      border-radius: 6px;
                      font-size: 11px;
                      font-weight: bold;
                      cursor: pointer;
                      letter-spacing: 0.5px;
                    ">
                    SHOW DEMO
                  </button>
                </div>
              </div>
            </div>
          </div>
        </template>

        <!-- DEFAULT: ROCKET RACE -->
        <template v-else>
          <div class="gt-race-track">
            <div v-for="(team, index) in sortedTeams" :key="team.id" class="gt-rocket-lane">
              <div
                class="gt-rocket-wrapper"
                :class="{'rocket-moving': movingTeams.has(team.id), 'rocket-finished': team.progress >= 100}"
                :style="{bottom: getRocketBottom(team.progress) + '%'}">
                <div class="gt-rocket-label" :style="{borderColor: team.color, color: team.color}">
                  {{ team.name.replace('TEAM ', 'T') }} • {{ team.score || 0 }}
                  <div v-if="teamScorePopups[team.id]" class="gt-score-popup">+2</div>
                </div>
                <div class="gt-rocket-icon" :style="{color: team.color}">
                  <svg class="rocket-svg" viewBox="0 0 680 580" xmlns="http://www.w3.org/2000/svg">
                    <defs>
                      <radialGradient :id="'g1-' + team.id" cx="50%" cy="88%" r="70%" spreadMethod="pad">
                        <stop offset="0%" stop-color="#FFFFFF" />
                        <stop offset="10%" stop-color="#E0FFFF" />
                        <stop offset="30%" stop-color="#00FFFF" />
                        <stop offset="55%" stop-color="#0088FF" />
                        <stop offset="85%" stop-color="#0033CC" />
                        <stop offset="100%" stop-color="#001A66" stop-opacity="0" />
                      </radialGradient>
                      <filter :id="'hyper-glow-' + team.id">
                        <feGaussianBlur stdDeviation="3.5" result="coloredBlur" />
                        <feMerge>
                          <feMergeNode in="coloredBlur" />
                          <feMergeNode in="SourceGraphic" />
                        </feMerge>
                      </filter>
                      <radialGradient :id="'g2-' + team.id" cx="50%" cy="90%" r="60%">
                        <stop offset="0%" stop-color="#FFFFFF" />
                        <stop offset="15%" stop-color="#CCFFFF" />
                        <stop offset="45%" stop-color="#00DDFF" />
                        <stop offset="80%" stop-color="#0055FF" />
                        <stop offset="100%" stop-color="#0022AA" stop-opacity="0" />
                      </radialGradient>
                      <radialGradient :id="'g3-' + team.id" cx="50%" cy="92%" r="46%">
                        <stop offset="0%" stop-color="#FFFFFF" />
                        <stop offset="12%" stop-color="#E0FFFF" />
                        <stop offset="55%" stop-color="#00CCFF" />
                        <stop offset="100%" stop-color="#0066FF" stop-opacity="0" />
                      </radialGradient>
                      <radialGradient :id="'g4-' + team.id" cx="50%" cy="95%" r="40%">
                        <stop offset="0%" stop-color="#FFFFFF" />
                        <stop offset="30%" stop-color="#CCFFFF" />
                        <stop offset="100%" stop-color="#00EEFF" stop-opacity="0" />
                      </radialGradient>
                      <radialGradient :id="'glow1-' + team.id" cx="50%" cy="72%" r="65%">
                        <stop offset="0%" stop-color="#00FFFF" stop-opacity=".92" />
                        <stop offset="50%" stop-color="#0088FF" stop-opacity=".52" />
                        <stop offset="100%" stop-color="#0033CC" stop-opacity="0" />
                      </radialGradient>
                      <radialGradient :id="'glow2-' + team.id" cx="50%" cy="68%" r="78%">
                        <stop offset="0%" stop-color="#00CCFF" stop-opacity=".42" />
                        <stop offset="100%" stop-color="#0022AA" stop-opacity="0" />
                      </radialGradient>
                      <!-- Fire gradients for progress >= 100 -->
                      <radialGradient :id="'g1-fire-' + team.id" cx="50%" cy="88%" r="70%" spreadMethod="pad">
                        <stop offset="0%" stop-color="#FFFFFF" />
                        <stop offset="10%" stop-color="#FFFCF0" />
                        <stop offset="30%" stop-color="#FFE000" />
                        <stop offset="55%" stop-color="#FF7000" />
                        <stop offset="85%" stop-color="#CC0000" />
                        <stop offset="100%" stop-color="#AA0000" stop-opacity="0" />
                      </radialGradient>
                      <radialGradient :id="'g2-fire-' + team.id" cx="50%" cy="90%" r="60%">
                        <stop offset="0%" stop-color="#FFFFFF" />
                        <stop offset="15%" stop-color="#FFF8B0" />
                        <stop offset="45%" stop-color="#FFCC00" />
                        <stop offset="80%" stop-color="#FF5500" />
                        <stop offset="100%" stop-color="#FF2200" stop-opacity="0" />
                      </radialGradient>
                      <radialGradient :id="'g3-fire-' + team.id" cx="50%" cy="92%" r="46%">
                        <stop offset="0%" stop-color="#FFFFFF" />
                        <stop offset="12%" stop-color="#FFFFF0" />
                        <stop offset="55%" stop-color="#FFE800" />
                        <stop offset="100%" stop-color="#FF9900" stop-opacity="0" />
                      </radialGradient>
                      <radialGradient :id="'g4-fire-' + team.id" cx="50%" cy="95%" r="40%">
                        <stop offset="0%" stop-color="#FFFFFF" />
                        <stop offset="30%" stop-color="#FFFDE8" />
                        <stop offset="100%" stop-color="#FFE000" stop-opacity="0" />
                      </radialGradient>
                      <radialGradient :id="'glow1-fire-' + team.id" cx="50%" cy="72%" r="65%">
                        <stop offset="0%" stop-color="#FFAA00" stop-opacity=".92" />
                        <stop offset="50%" stop-color="#FF5500" stop-opacity=".52" />
                        <stop offset="100%" stop-color="#FF2200" stop-opacity="0" />
                      </radialGradient>
                      <radialGradient :id="'glow2-fire-' + team.id" cx="50%" cy="68%" r="78%">
                        <stop offset="0%" stop-color="#FF8800" stop-opacity=".42" />
                        <stop offset="100%" stop-color="#FF2200" stop-opacity="0" />
                      </radialGradient>
                      <linearGradient :id="'bodyMain-' + team.id" x1="0%" y1="0%" x2="100%" y2="0%">
                        <stop offset="0%" stop-color="#8A94A8" />
                        <stop offset="18%" stop-color="#C8D0DC" />
                        <stop offset="38%" stop-color="#EEF2F8" />
                        <stop offset="55%" stop-color="#F8FAFE" />
                        <stop offset="72%" stop-color="#D8DDE8" />
                        <stop offset="88%" stop-color="#A8B0C0" />
                        <stop offset="100%" stop-color="#788090" />
                      </linearGradient>
                      <linearGradient :id="'noseCone-' + team.id" x1="0%" y1="0%" x2="100%" y2="0%">
                        <stop offset="0%" stop-color="#6A7488" />
                        <stop offset="22%" stop-color="#A8B4C4" />
                        <stop offset="45%" stop-color="#D0D8E4" />
                        <stop offset="62%" stop-color="#E4EAF2" />
                        <stop offset="78%" stop-color="#B8C0CC" />
                        <stop offset="100%" stop-color="#687080" />
                      </linearGradient>
                      <linearGradient :id="'wingGrad-' + team.id" x1="0%" y1="0%" x2="100%" y2="0%">
                        <stop offset="0%" stop-color="#556070" />
                        <stop offset="40%" stop-color="#8A94A4" />
                        <stop offset="100%" stop-color="#6A7080" />
                      </linearGradient>
                      <linearGradient :id="'nozzleGrad-' + team.id" x1="0%" y1="0%" x2="100%" y2="0%">
                        <stop offset="0%" stop-color="#404850" />
                        <stop offset="30%" stop-color="#788090" />
                        <stop offset="55%" stop-color="#909AA8" />
                        <stop offset="80%" stop-color="#687078" />
                        <stop offset="100%" stop-color="#404850" />
                      </linearGradient>
                      <linearGradient :id="'nozzleRim-' + team.id" x1="0%" y1="0%" x2="100%" y2="0%">
                        <stop offset="0%" stop-color="#303840" />
                        <stop offset="40%" stop-color="#606870" />
                        <stop offset="100%" stop-color="#303840" />
                      </linearGradient>
                      <radialGradient :id="'windowOuter-' + team.id" cx="38%" cy="32%" r="62%">
                        <stop offset="0%" stop-color="#CCE8FF" />
                        <stop offset="45%" stop-color="#4AACEE" />
                        <stop offset="80%" stop-color="#1A6A9A" />
                        <stop offset="100%" stop-color="#0A3A5A" />
                      </radialGradient>
                      <radialGradient :id="'windowInner-' + team.id" cx="32%" cy="28%" r="55%">
                        <stop offset="0%" stop-color="white" stop-opacity=".9" />
                        <stop offset="100%" stop-color="white" stop-opacity="0" />
                      </radialGradient>
                      <linearGradient :id="'stripe1-' + team.id" x1="0%" y1="0%" x2="100%" y2="0%">
                        <stop offset="0%" stop-color="#1A2A6A" stop-opacity=".0" />
                        <stop offset="30%" stop-color="#1A2A6A" stop-opacity=".75" />
                        <stop offset="70%" stop-color="#1A2A6A" stop-opacity=".75" />
                        <stop offset="100%" stop-color="#1A2A6A" stop-opacity=".0" />
                      </linearGradient>
                      <linearGradient :id="'stripe2-' + team.id" x1="0%" y1="0%" x2="100%" y2="0%">
                        <stop offset="0%" stop-color="#8A0010" stop-opacity=".0" />
                        <stop offset="30%" stop-color="#8A0010" stop-opacity=".8" />
                        <stop offset="70%" stop-color="#8A0010" stop-opacity=".8" />
                        <stop offset="100%" stop-color="#8A0010" stop-opacity=".0" />
                      </linearGradient>
                      <linearGradient :id="'heatShield-' + team.id" x1="0%" y1="0%" x2="100%" y2="0%">
                        <stop offset="0%" stop-color="#4A3020" stop-opacity=".0" />
                        <stop offset="35%" stop-color="#6A4428" stop-opacity=".6" />
                        <stop offset="65%" stop-color="#6A4428" stop-opacity=".6" />
                        <stop offset="100%" stop-color="#4A3020" stop-opacity=".0" />
                      </linearGradient>
                      <linearGradient :id="'panelLine-' + team.id" x1="0%" y1="0%" x2="100%" y2="0%">
                        <stop offset="0%" stop-color="#607080" stop-opacity="0" />
                        <stop offset="30%" stop-color="#607080" stop-opacity=".5" />
                        <stop offset="70%" stop-color="#607080" stop-opacity=".5" />
                        <stop offset="100%" stop-color="#607080" stop-opacity="0" />
                      </linearGradient>
                      <radialGradient :id="'exhaustChamber-' + team.id" cx="50%" cy="20%" r="70%">
                        <stop offset="0%" stop-color="#FF6600" stop-opacity=".9" />
                        <stop offset="60%" stop-color="#CC2200" stop-opacity=".6" />
                        <stop offset="100%" stop-color="#440000" stop-opacity=".8" />
                      </radialGradient>
                      <clipPath :id="'bodyClip-' + team.id">
                        <rect x="304" y="128" width="72" height="175" rx="6" />
                      </clipPath>
                    </defs>

                    <g class="rg">
                      <!-- Rocket body image -->
                      <image :href="rocketImgSrc" x="60" y="-20" width="560" height="370" />
                      <ellipse
                        cx="340"
                        cy="328"
                        rx="70"
                        ry="24"
                        :fill="team.progress >= 100 ? 'url(#glow2-fire-' + team.id + ')' : 'url(#glow2-' + team.id + ')'"
                        class="gl" />
                      <ellipse
                        cx="340"
                        cy="315"
                        rx="50"
                        ry="17"
                        :fill="team.progress >= 100 ? 'url(#glow1-fire-' + team.id + ')' : 'url(#glow1-' + team.id + ')'"
                        class="gl" />
                      <!-- Flame layers: longer + fire-colored when progress >= 100 -->
                      <g :transform="team.progress >= 100 ? 'translate(340,298) scale(1,1.5) translate(-340,-298)' : ''">
                        <g class="l1">
                          <path
                            d="M298 298 Q314 368 340 500 Q366 368 382 298 Q364 322 340 327 Q316 322 298 298Z"
                            :fill="team.progress >= 100 ? 'url(#g1-fire-' + team.id + ')' : 'url(#g1-' + team.id + ')'"
                            :filter="'url(#hyper-glow-' + team.id + ')'" />
                        </g>
                        <g class="l2">
                          <path
                            d="M306 298 Q320 358 340 480 Q360 358 374 298 Q360 318 340 323 Q320 318 306 298Z"
                            :fill="team.progress >= 100 ? 'url(#g2-fire-' + team.id + ')' : 'url(#g2-' + team.id + ')'"
                            :filter="'url(#hyper-glow-' + team.id + ')'" />
                        </g>
                        <g class="l3">
                          <path
                            d="M314 299 Q326 345 340 450 Q354 345 366 299 Q355 316 340 320 Q325 316 314 299Z"
                            :fill="team.progress >= 100 ? 'url(#g3-fire-' + team.id + ')' : 'url(#g3-' + team.id + ')'"
                            :filter="'url(#hyper-glow-' + team.id + ')'" />
                        </g>
                        <g class="l4">
                          <path
                            d="M321 300 Q332 335 340 420 Q348 335 359 300 Q351 313 340 316 Q329 313 321 300Z"
                            :fill="team.progress >= 100 ? 'url(#g4-fire-' + team.id + ')' : 'url(#g4-' + team.id + ')'"
                            :filter="'url(#hyper-glow-' + team.id + ')'" />
                        </g>
                        <path
                          d="M331 300 Q336 324 340 390 Q344 324 349 300 Q345 309 340 311 Q335 309 331 300Z"
                          fill="white"
                          opacity=".96"
                          :filter="'url(#hyper-glow-' + team.id + ')'" />
                        <g class="l2">
                          <path
                            d="M306 298 Q320 358 340 412 Q360 358 374 298 Q360 318 340 323 Q320 318 306 298Z"
                            :fill="team.progress >= 100 ? 'url(#g2-fire-' + team.id + ')' : 'url(#g2-' + team.id + ')'" />
                        </g>
                        <g class="l3">
                          <path
                            d="M314 299 Q326 345 340 388 Q354 345 366 299 Q355 316 340 320 Q325 316 314 299Z"
                            :fill="team.progress >= 100 ? 'url(#g3-fire-' + team.id + ')' : 'url(#g3-' + team.id + ')'" />
                        </g>
                        <g class="l4">
                          <path
                            d="M321 300 Q332 335 340 364 Q348 335 359 300 Q351 313 340 316 Q329 313 321 300Z"
                            :fill="team.progress >= 100 ? 'url(#g4-fire-' + team.id + ')' : 'url(#g4-' + team.id + ')'" />
                        </g>
                        <path d="M331 300 Q336 324 340 346 Q344 324 349 300 Q345 309 340 311 Q335 309 331 300Z" fill="white" opacity=".96" />
                        <ellipse cx="340" cy="302" rx="7" ry="4" :fill="team.progress >= 100 ? '#FFE044' : '#00FFFF'" class="s1" />
                        <ellipse cx="340" cy="302" rx="5" ry="3" :fill="team.progress >= 100 ? '#FF8800' : '#0088FF'" class="s2" />
                        <circle cx="340" cy="302" r="4" :fill="team.progress >= 100 ? '#FFEE44' : '#CCFFFF'" class="s3" />
                        <circle cx="340" cy="302" r="3.5" :fill="team.progress >= 100 ? '#FF6600' : '#0055FF'" class="s4" />
                        <ellipse cx="340" cy="302" rx="5" ry="3" :fill="team.progress >= 100 ? '#FFD844' : '#00DDFF'" class="s5" />
                        <circle cx="340" cy="302" r="3" :fill="team.progress >= 100 ? '#FF9900' : '#0099FF'" class="s6" />
                        <circle cx="340" cy="302" r="5" :fill="team.progress >= 100 ? '#FFCC00' : '#00EEFF'" class="s7" />
                        <ellipse cx="340" cy="302" rx="6" ry="3.5" :fill="team.progress >= 100 ? '#FF5500' : '#0066FF'" class="s8" />
                        <circle cx="340" cy="302" r="3" :fill="team.progress >= 100 ? '#FFAA00' : '#00BBFF'" class="s9" />
                        <ellipse cx="340" cy="302" rx="4" ry="2.5" :fill="team.progress >= 100 ? '#FFE000' : '#00FFEE'" class="s10" />
                        <ellipse cx="340" cy="302" rx="9" ry="5" :fill="team.progress >= 100 ? '#FF9900' : '#0099FF'" opacity=".44" class="w1" />
                        <ellipse cx="340" cy="302" rx="7" ry="4" :fill="team.progress >= 100 ? '#FF7700' : '#0077FF'" opacity=".36" class="w2" />
                        <ellipse cx="340" cy="302" rx="6" ry="3.5" :fill="team.progress >= 100 ? '#FFCC00' : '#00DDFF'" opacity=".4" class="w3" />
                        <ellipse cx="340" cy="302" rx="8" ry="4.5" :fill="team.progress >= 100 ? '#FF6600' : '#0055FF'" opacity=".28" class="w4" />
                      </g>
                    </g>
                  </svg>
                  <div class="gt-rocket-tail" :style="{background: `linear-gradient(to bottom, ${team.color}, transparent)`}"></div>
                </div>
                <div v-if="team.activeMember" class="gt-rocket-avatar" :style="{borderColor: team.color}">
                  <img v-if="team.activeMember.avatar" :src="team.activeMember.avatar" />
                  <span v-else>{{ getInitials(team.activeMember.name) }}</span>
                  <div class="gt-avatar-tooltip" :style="{borderColor: team.color}">{{ team.activeMember.tooltip }}</div>
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>

      <!-- RIGHT PANEL: LOGS (dashboard only) -->
      <div
        v-if="isDashboard"
        class="gt-right-panel"
        :class="{'gt-hide-on-mobile': activeDashboardMobileTab !== 'logs', 'gt-show-on-mobile-flex': activeDashboardMobileTab === 'logs'}">
        <div class="gt-log-header"><i class="fa fa-list"></i> MISSION ACTIVITY LOG</div>
        <div class="gt-log-list">
          <div v-for="(log, idx) in activityLogs" :key="idx" class="gt-log-item">
            <i class="fa" :class="log.iconClass" :style="{color: log.color}" style="font-size: 16px; margin-right: 10px"></i>
            <span v-html="log.text"></span>
          </div>
          <!-- <div class="gt-log-processing">Processing ...</div> -->
        </div>
      </div>
    </div>

    <!-- MOBILE-ONLY: End Game button outside scrollable area -->
    <button class="gt-mobile-end-btn" @click="endGame(true)">END GAME</button>

    <!-- IMAGE PREVIEW OVERLAY -->
    <div v-if="previewPicUrl" class="gs-preview-overlay" @click.stop="closePreview">
      <div class="gs-preview-close" @click.stop="closePreview"><i class="fa fa-times"></i></div>
      <img :src="Fn.hashToUrl(previewPicUrl)" alt="Preview" class="gs-preview-image" @click.stop />
    </div>

    <!-- Modals moved to be direct children of gt-overlay for better z-index/visibility -->
    <SlideAnalyticsModal
      v-if="showSlideAnalytics"
      :slide="selectedAnalysisSlide"
      :responses="responses"
      :analysis="analysis"
      @close="closeSlideAnalytics"
      @close-all="closeAllAnalytics"
      @open-cpa-demo="openCpaDemo" />

    <DemoReplayPage v-if="showCpaDemo" :curQuestion="selectedCpaDemoSlide" :roomId="roomId" @close="closeCpaDemo" />

    <GameOverModal
      v-if="showGameOver"
      :teams="liveTeams"
      :analysis="analysis"
      :slides="gameConfig.slides"
      :session-questions="session.questions"
      :winner-id="winnerId"
      :status="gameStatus"
      @close="closeGameOver"
      @declare-winner="onDeclareWinner" />
  </div>
</template>

<script>
import {mapActions, mapState, mapGetters} from 'vuex'
import {showLoading, hideLoading} from '@/utils/loading'
import GameOverModal from './GameOverModal.vue'
import SlideAnalyticsModal from './SlideAnalyticsModal.vue'
import DemoReplayPage from './DemoReplayPage.vue'

const rocketSoundSrc = require('./sounds/rocket-sound.mp3')

export default {
  name: 'GameTrackingPage',
  components: {
    GameOverModal,
    SlideAnalyticsModal,
    DemoReplayPage,
  },
  props: {
    gameConfig: {type: Object, required: true},
    teams: {type: Array, required: true},
    isDashboard: {type: Boolean, default: false},
  },
  data() {
    return {
      activeProjectorMobileTab: 'race',
      activeDashboardMobileTab: 'analytics',
      expandedDashboardCards: {},
      showGameOver: false,
      timeRemaining: 0,
      totalTime: 300,
      timerInterval: null,
      movingTeams: new Set(),
      rocketSound: null,
      activityLogs: [],
      latestActivity: '',
      liveTeams: [],
      responses: [],
      analysis: null,
      currentSlideIndex: 0,
      showSlideAnalytics: false,
      selectedAnalysisSlide: null,
      showCpaDemo: false,
      selectedCpaDemoSlide: null,
      teamScorePopups: {},
      previewPicUrl: null,
      previewCpaData: null,
      activeTooltipSlideId: null,
      rocketImgSrc: require('../../../assets/Rocket.png'),
      winnerId: null,
      gameStatus: 1,
    }
  },
  computed: {
    ...mapState(['session', 'user']),
    roomId() {
      return this.$route && this.$route.params && this.$route.params.id
    },
    ...mapState('teacher', ['gameOnRecentAnswer']),
    ...mapGetters(['isShowStudentName']),
    sortedTeams() {
      // Sort by score descending
      return [...this.liveTeams].sort((a, b) => (b.score || 0) - (a.score || 0))
    },
    currentSlide() {
      const slides = this.gameConfig && this.gameConfig.slides
      if (!slides || !slides.length) return null
      return slides[this.currentSlideIndex] || slides[0]
    },
  },
  watch: {
    gameOnRecentAnswer(newAnswer) {
      if (newAnswer) {
        this.processIncomingAnswer(newAnswer)
      }
    },
    gameConfig: {
      handler(val) {
        if (val) {
          if (val.gameStatus) this.gameStatus = val.gameStatus
          if (val.showGameOver !== undefined) this.showGameOver = val.showGameOver
          if (val.analysis) this.analysis = val.analysis
          if (val.winnerId) this.winnerId = val.winnerId
          if (val.gameOnRecord && val.gameOnRecord.winnerId) this.winnerId = val.gameOnRecord.winnerId
        }
      },
      deep: true,
    },
    'gameConfig.gameOnRecord.expiresAt': {
      handler(newExpiresAt) {
        if (newExpiresAt && !this.isDashboard) {
          this.startTimer(newExpiresAt)
        }
      },
    },
    'gameConfig.gameOnRecord': {
      handler(val) {
        if (val) {
          
          if (val.status === 2 && !this.showGameOver) {
          this.updateTeamsFromRecord(val)

            this.endGame()
          }
        }
      },
      deep: true,
      immediate: true,
    },
    timeRemaining(val) {
      // Only trigger end game if timer was actually running
      if (val <= 0 && !this.showGameOver && this.timerInterval) {
        this.endGame(false)
      }
    },
    'session.demoReplay': {
      handler(val) {
        if (!val && this.showCpaDemo) {
          this.showCpaDemo = false
          this.selectedCpaDemoSlide = null
        }
      }
    },
  },
  mounted() {
    this.rocketSound = new Audio(rocketSoundSrc)
    this.rocketSound.volume = 0.6
    this.initGame()
  },
  beforeDestroy() {
    if (this.timerInterval) clearInterval(this.timerInterval)
    if (this.unsubscribe) this.unsubscribe()
    if (window.App && this.boundPatchListener) {
      window.App.service('game-on').removeListener('patched', this.boundPatchListener)
    }
    if (window.App && this.boundScoresListener) {
      window.App.service('game-on').removeListener('updatedScores', this.boundScoresListener)
    }
    if (window.App && this.boundExpiresAtListener) {
      window.App.service('game-on').removeListener('updatedExpiresAt', this.boundExpiresAtListener)
    }
    if (window.App && this.boundGameEndedListener) {
      window.App.service('game-on').removeListener('gameEnded', this.boundGameEndedListener)
    }
     if (window.App && this.boundLatestLogListener) {
      window.App.service('game-on').removeListener('latestLog', this.boundLatestLogListener)
    }
  },
  destroyed() {
    // Managed by Vue; z-index handles overlaying.
  },
  methods: {
    hasValidAnswer(slide) {
      const fullQuestion = this.getFullQuestion(slide)
      if (!fullQuestion || !fullQuestion.options) return false
      try {
        const opts = typeof fullQuestion.options === 'string' ? JSON.parse(fullQuestion.options) : fullQuestion.options
        if (!Array.isArray(opts)) return false
        return opts.some((opt) => opt.on === true || opt.isCorrect === true)
      } catch (e) {
        return false
      }
    },
    async initGame() {
      const record = this.gameConfig && this.gameConfig.gameOnRecord
      const classMembers =
        (this.$store && this.$store.state && this.$store.state.teacher && this.$store.state.teacher.rooms && this.$store.state.teacher.rooms.members) || []

      // Enrich raw DB members with name/avatar from class roster
      const rawMembers = (record && record.members) || []
      const enrichedMembers = rawMembers.map((m, idx) => {
        const user = classMembers.find((c) => c._id === m.uid) || {}
        let mName = typeof m.name === 'string' ? m.name : Array.isArray(m.name) ? m.name.join(' ') : null
        let cName = user.nickname || user.name

        return {
          uid: m.uid,
          id: m.uid,
          teamId: m.teamId,
          score: m.score || 0,
          name: mName || cName || 'Unknown',
          avatar: m.avatar || user.avatar || user.pic || '',
          colorIndex: idx,
          lockedPages: m.lockedPages || [],
          correctPages: m.correctPages || [],
        }
      })

      // Build liveTeams — teams come from the prop (already enriched with color from TeamSelectionModal)
      this.liveTeams = (this.teams || []).map((t) => ({
        ...t,
        score: t.score || 0,
        progress: t.progress || 0,
        members: enrichedMembers.filter((m) => m.teamId === t.id),
      }))

      // Start timer from record's expiresAt if already available
      this.gameStatus = record ? record.status : 1
      this.winnerId = record ? (record.winnerId || null) : null
      
      if (record && record.expiresAt && record.status === 1) {
        this.startTimer(record.expiresAt)
      } else if (record && record.status === 2) {
        this.endGame()
      }

      // Listen to real-time patch
      if (window.App && record && (record._id || record.id)) {
        const rId = record._id || record.id
        this.boundPatchListener = (patchRecord) => {
          const pId = patchRecord._id || patchRecord.id
          if (pId === rId) {
            // Trigger the record watcher by updating the object
            if (this.gameConfig && this.gameConfig.gameOnRecord) {
              this.$set(this.gameConfig, 'gameOnRecord', {
                ...this.gameConfig.gameOnRecord,
                ...patchRecord,
              })
            }
          }
        }
        window.App.service('game-on').on('patched', this.boundPatchListener)

        this.boundScoresListener = (data) => {
          if (data && (data._id === record._id || !data._id)) {
            const {updatedTeam, updatedMember, scoreUpdated, updatedSlideId} = data
            
            const getOrdinal = (n) => {
              const s = ['th', 'st', 'nd', 'rd']
              const v = n % 100
              return `${n}${s[(v - 20) % 10] || s[v] || s[0]}`
            }
            const slideNumber = this.gameConfig.slides.findIndex((slide) => slide.id === updatedSlideId) + 1
            const slideLabel = getOrdinal(slideNumber)

            if (updatedTeam && updatedMember) {
              const liveMatch = this.liveTeams.find((lt) => lt.id === (updatedTeam.id || updatedTeam.teamId))
              if (liveMatch) {
                let mName = Array.isArray(updatedMember.name) ? updatedMember.name.join(' ') : updatedMember.name || 'Student'
                // find matching member for avatar from local state if missing
                let mAvatar = updatedMember.avatar
                if (!mAvatar) {
                  const mm = liveMatch.members.find((m) => m.uid === updatedMember.uid)
                  if (mm) mAvatar = mm.avatar || ''
                }
                
                const liveMember = liveMatch.members.find((m) => m.uid === updatedMember.uid || m.id === updatedMember.uid)
                if (liveMember) {
                  if (!liveMember.lockedPages) this.$set(liveMember, 'lockedPages', [])
                  if (!liveMember.correctPages) this.$set(liveMember, 'correctPages', [])
                  if (updatedSlideId && !liveMember.lockedPages.includes(updatedSlideId)) {
                    liveMember.lockedPages.push(updatedSlideId)
                  }
                  if (scoreUpdated && updatedSlideId && !liveMember.correctPages.includes(updatedSlideId)) {
                    liveMember.correctPages.push(updatedSlideId)
                  }
                }

                this.$set(liveMatch, 'activeMember', {
                  uid: updatedMember.uid,
                  name: mName,
                  avatar: mAvatar,
                  tooltip: `${mName} ${scoreUpdated ? 'answered' : 'attempted'} ${slideLabel} question`,
                })
                if (liveMatch.avatarTimeout) clearTimeout(liveMatch.avatarTimeout)
                liveMatch.avatarTimeout = setTimeout(() => {
                  this.$set(liveMatch, 'activeMember', null)
                }, 3000)
              }

              
            }
            // console.log("calling 936", data)
            this.updateTeamsFromRecord(data)
            // Surface score change in the activity log
            const highestTeam = [...this.liveTeams].sort((a, b) => (b.score || 0) - (a.score || 0))[0]
            if (highestTeam) {
              this.latestActivity = `<b>${highestTeam.name}</b> is leading with ${highestTeam.score} pts`
            }
          
          }
        }
        window.App.service('game-on').on('updatedScores', this.boundScoresListener)


        this.boundExpiresAtListener = (data) => {
          if (data && data.roomId === record._id) {
            if (data.expiresAt) {
              this.startTimer(data.expiresAt)
            }
          }
        }
        window.App.service('game-on').on('updatedExpiresAt', this.boundExpiresAtListener)
        
        this.boundGameEndedListener = (data) => {
          if (data && data.roomId === record._id) {
            if (data.status) {
              this.gameStatus = Number(data.status)
            }
            if (data.analysis) {
              this.analysis = data.analysis
              if (this.gameConfig) {
                this.$set(this.gameConfig, 'analysis', data.analysis)
              }
            }

            // Sync to session for projector view
            if (this.isDashboard && this.session && this.session.gameOnTracking) {
              const updatedTracking = JSON.parse(JSON.stringify(this.session.gameOnTracking))
              if (updatedTracking.gameConfig) {
                updatedTracking.gameConfig.gameStatus = this.gameStatus
                updatedTracking.gameConfig.analysis = this.analysis
                updatedTracking.gameConfig.showGameOver = this.showGameOver
                this.$store.dispatch('upSession', {gameOnTracking: updatedTracking})
              }
            }
          }
        }
        window.App.service('game-on').on('gameEnded', this.boundGameEndedListener)

        this.boundLatestLogListener = (data) => {
          if (data && data.roomId === record._id) {
            if (data.log) {
              this.activityLogs.unshift({
                text: data.log.text,
                color: data.log.color,
                iconClass: data.log.iconClass,
              })
            }
           
          }
        }
        window.App.service('game-on').on('latestLog', this.boundLatestLogListener)


        // Fetch current state immediately
        window.App.service('game-on')
          .get(record._id)
          .then((curr) => {
            this.updateTeamsFromRecord(curr)
            // (Re)start timer using latest expiresAt from server
            if (curr.expiresAt) {
              if (this.timerInterval) clearInterval(this.timerInterval)
              this.startTimer(curr.expiresAt)
            }
          })
          .catch((err) => console.error(err))
      }

      // BROADCAST QUESTIONS TO STUDENTS FOR MISSION LOG
      if (window.App && this.gameConfig && this.gameConfig.slides) {
        window.App.service('auth').patch('syncTeacher', {
          commit: 'student/setActiveMissionQuestions',
          data: this.gameConfig.slides,
        })
      }

      this.activityLogs.unshift({
        text: 'Game Tracking Initialized. Waiting for Student Real-Time Submissions...',
        color: '#00ffff',
        iconClass: 'fa-info-circle',
      })

      const activityResponses = await window.App.service('game-on-log').find({
        query: {
          gameId: record._id,
          $limit: '20',
        },
      })
       activityResponses?.data?.forEach((log) => {
        this.activityLogs.unshift({
          text: log.text,
          color: log.color,
          iconClass: log.iconClass,
        })
      })
    },
    startTimer(expiresAt) {
      const expiresTime = new Date(expiresAt).getTime()
      this.currentExpiresTime = expiresTime

      const timePerQuestion = (this.gameConfig && (this.gameConfig.timing || this.gameConfig.time)) || 120
      const totalSlides = (this.gameConfig && this.gameConfig.slides && this.gameConfig.slides.length) || 1
      this.totalTime = timePerQuestion * totalSlides

      // clear old timer
      if (this.timerInterval) {
        clearInterval(this.timerInterval)
      }

      const update = () => {
        // Stop timer visually if demo replay is active
        if (this.showCpaDemo || (this.session && this.session.demoReplay)) return

        const now = Date.now()
        const diff = Math.floor((expiresTime - now) / 1000)
        this.timeRemaining = Math.max(0, diff)

        if (diff <= 0) {
          this.endGame(false)
        }
      }

      // run immediately then every second
      update()
      this.timerInterval = setInterval(update, 1000)
    },
    updateTeamsFromRecord(record) {
      if (!record) return
      
      console.log("[GameOnSync] Updating teams from record:", record)

      // Sync top-level status and IDs
      if (record.status !== undefined) {
        this.gameStatus = Number(record.status)
      }
      if (record.winnerId !== undefined) {
        this.winnerId = record.winnerId || null
      }
      if (record.analysis) {
        this.analysis = record.analysis
      }
      if (record.expiresAt && record.status === 1 && record.expiresAt !== this.currentExpiresTime) {
        this.startTimer(record.expiresAt)
      }
      // Demo sync
      if (record.isDemoOn === false && this.showCpaDemo) {
        this.showCpaDemo = false
        this.selectedCpaDemoSlide = null
      }

      if (record.responses && Array.isArray(record.responses)) {
        this.responses = record.responses
      }

      // 1. Sync team-level scores
      if (record.teams && Array.isArray(record.teams)) {
        this.liveTeams = this.liveTeams.map((t) => {
          const dbTeam = record.teams.find((dbt) => dbt.id === t.id)
          if (dbTeam && (dbTeam.score || 0) > (t.score || 0)) {
            this.$set(this.teamScorePopups, t.id, true)
            setTimeout(() => {
              this.$set(this.teamScorePopups, t.id, false)
            }, 2000)
          }
          if (dbTeam && (dbTeam.progress || 0) !== (t.progress || 0)) {
            // Trigger vibration for this team
            const newMoving = new Set(this.movingTeams)
            newMoving.add(t.id)
            this.movingTeams = newMoving

            if (dbTeam.progress >= 100 && (t.progress || 0) < 100) {
              this.playRocketSound()
            }

            setTimeout(() => {
              const updated = new Set(this.movingTeams)
              updated.delete(t.id)
              this.movingTeams = updated
            }, 1200)
          }
          return dbTeam ? {...t, score: dbTeam.score || 0, progress: dbTeam.progress || 0} : t
        })
      }
       // 2. Sync member-level scores and progress (real-time per-student updates)
      const updateMemberObj = (m, dbMember) => {
        return {
          ...m,
          score: dbMember.score || 0,
          lockedPages: dbMember.lockedPages || [],
          correctPages: dbMember.correctPages || [],
        }
      }

      if (record.members && Array.isArray(record.members)) {
        this.liveTeams = this.liveTeams.map((t) => ({
          ...t,
          members: (t.members || []).map((m) => {
            const dbMember = record.members.find((dm) => dm.uid === m.uid)
            return dbMember ? updateMemberObj(m, dbMember) : m
          }),
        }))
      } else if (record.updatedMember) {
        // Handle single member update from socket events
        const um = record.updatedMember
        this.liveTeams = this.liveTeams.map((t) => {
          if (t.id === (um.teamId || um.team_id)) {
            return {
              ...t,
              members: (t.members || []).map((m) => {
                return m.uid === um.uid ? updateMemberObj(m, um) : m
              }),
            }
          }
          return t
        })
      }
      // 2. Sync member-level scores (real-time per-student score updates)
      if (record.members && Array.isArray(record.members)) {
        this.liveTeams = this.liveTeams.map((t) => ({
          ...t,
          members: t.members.map((m) => {
            const dbMember = record.members.find((dm) => dm.uid === m.uid)
            return dbMember ? {...m, score: dbMember.score || 0} : m
          }),
        }))
      }
    },
    handleNativeResponse(rs) {
      if (this.timeRemaining <= 0) return

      // 1. Map incoming Feathers response student identity back to their strict GameOn team bounds
      const studentId = rs.user_id || rs.uid || rs.studentId
      let matchingTeam = null
      let memberObj = null

      for (const team of this.liveTeams) {
        const member = team.members.find((m) => m.uid === studentId)
        if (member) {
          matchingTeam = team
          memberObj = member
          break
        }
      }

      // Discard responses from students who aren't currently part of an active racing team
      if (!matchingTeam) return

      // 2. Validate Slide bounds
      const slide = this.gameConfig.slides.find((s) => s.id === rs.page || s.id === rs.page_id || s.id === rs.quizId)

      // 3. Process the validation format & apply point mappings
      const isCorrect = rs.isRight === true || rs.correct === true || rs.score > 0 || (rs.answer && slide && slide.answer && rs.answer === slide.answer) || true // Fallback Boolean flag
      const pointsAwarded = slide && slide.points ? slide.points : 25
      const displayName = memberObj.name || memberObj.nickname || 'Student'

      // if (!this.hasValidAnswer(slide)) {
      //   this.activityLogs.unshift({
      //     text: `<b>${displayName}</b> from ${matchingTeam.name} attempted.`,
      //     color: '#00ffff',
      //     iconClass: 'fa-info-circle',
      //   })
      // } else if (isCorrect) {
      //   // Score update is now handled entirely by game-on backend
      //   this.activityLogs.unshift({
      //     text: `<b>${displayName}</b> from ${matchingTeam.name} answered correctly!`,
      //     color: '#00ff88',
      //     iconClass: 'fa-check-circle',
      //   })
      // } else {
      //   this.activityLogs.unshift({
      //     text: `<b>${displayName}</b> from ${matchingTeam.name} submitted an incorrect answer.`,
      //     color: '#ff3366',
      //     iconClass: 'fa-times-circle',
      //   })
      // }

      // Memory cleanup logic
      // if (this.activityLogs.length > 20) this.activityLogs.pop()

      // Update Local Responses for Real-Time card percentages
      const slideId = rs.page || rs.page_id || rs.quizId
      const existingResponseIndex = this.responses.findIndex(
        (r) => r.uid === studentId && (r.page === slideId || r.page_id === slideId || r.quizId === slideId)
      )
      if (existingResponseIndex !== -1) {
        this.responses.splice(existingResponseIndex, 1, {...this.responses[existingResponseIndex], ...rs})
      } else {
        this.responses.push({...rs, uid: studentId, page: slideId})
      }


      // Update Member progress locally for immediate stats update
      if (matchingTeam && memberObj && slideId) {
        if (!memberObj.lockedPages) this.$set(memberObj, 'lockedPages', [])
        if (!memberObj.lockedPages.includes(slideId)) {
          memberObj.lockedPages.push(slideId)
        }
        if (isCorrect) {
          if (!memberObj.correctPages) this.$set(memberObj, 'correctPages', [])
          if (!memberObj.correctPages.includes(slideId)) {
            memberObj.correctPages.push(slideId)
          }
        }
      }
    },
    goToSlide(idx) {
      const slides = this.gameConfig && this.gameConfig.slides
      if (!slides) return
      this.currentSlideIndex = Math.max(0, Math.min(idx, slides.length - 1))
    },
    prevSlide() {
      this.goToSlide(this.currentSlideIndex - 1)
    },
    nextSlide() {
      this.goToSlide(this.currentSlideIndex + 1)
    },
    formatTime(seconds) {
      const m = Math.floor(seconds / 60)
      const s = seconds % 60
      return `${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`
    },
    getInitials(name) {
      if (!name) return ''
      if (Array.isArray(name)) name = name.join(' ')
      const parts = name.trim().split(' ')
      if (parts.length === 1) return parts[0].substring(0, 2).toUpperCase()
      return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase()
    },
    getContrastColor(colorIndex) {
      return '#1a3c40'
    },
    playRocketSound() {
      if (this.rocketSound) {
        this.rocketSound.currentTime = 0
        this.rocketSound.play().catch(() => {})
      }
    },
    getRocketBottom(progress) {
      const minBottom = 8
      if (!progress) return minBottom
      const percentage = minBottom + (progress / 100) * 65
      return Math.min(percentage, 73)
    },
    closeSlideAnalytics() {
      this.showSlideAnalytics = false
    },
    closeAllAnalytics() {
      this.showSlideAnalytics = false
      this.closeGameOver()
    },
    openCpaDemo(slide) {
      this.showSlideAnalytics = false
      this.selectedCpaDemoSlide = {
        ...slide,
        ...this.getFullQuestion(slide),
      }
      this.showCpaDemo = true

      // Sync to session for projector view
      if (this.isDashboard) {
        try {
          this.$store.dispatch('upSession', {demoReplay: this.selectedCpaDemoSlide})
        } catch (e) {
          console.error('Failed to sync demoReplay to session:', e)
        }
      }

      const recordId = this.gameConfig && this.gameConfig.gameOnRecord && this.gameConfig.gameOnRecord._id
      if (recordId && window.App) {
        window.App.service('game-on').patch(recordId, {isDemoOn: true})
      }
    },
    closeCpaDemo() {
      this.showCpaDemo = false
      this.selectedCpaDemoSlide = null

      const recordId = this.gameConfig && this.gameConfig.gameOnRecord && this.gameConfig.gameOnRecord._id
      if (recordId && window.App) {
        window.App.service('game-on').patch(recordId, {isDemoOn: false})
      }

      // Clear from session for projector view
      if (this.isDashboard) {
        try {
          this.$store.dispatch('upSession', {demoReplay: null})
        } catch (e) {
          console.error('Failed to clear demoReplay from session:', e)
        }
      }
    },
    onDeclareWinner(team) {
      if (typeof window !== 'undefined' && window.App) {
        this.winnerId = team.id
        window.App.service('auth')
          .patch('syncTeacher', {
            commit: 'student/setGameWinner',
            data: team.id,
          })
          .catch((err) => console.error('Error syncing game winner', err))

        // Patch backend game-on record to trigger real-time 'patched' event on other screens
        const recordId = this.gameConfig && this.gameConfig.gameOnRecord && this.gameConfig.gameOnRecord._id
        if (recordId) {
          window.App.service('game-on').patch(recordId, {winnerId: team.id}).catch(err => console.error('Error patching winnerId to DB', err))
        }

        // Sync to session for other teacher/projector views
        if (this.session && this.session.gameOnTracking) {
          const updatedTracking = JSON.parse(JSON.stringify(this.session.gameOnTracking))
          if (updatedTracking.gameConfig && updatedTracking.gameConfig.gameOnRecord) {
            updatedTracking.gameConfig.gameOnRecord.winnerId = team.id
            updatedTracking.gameConfig.winnerId = team.id
            updatedTracking.gameConfig.gameOnRecord.status = 2
            updatedTracking.gameConfig.showGameOver = true
            updatedTracking.teams = this.liveTeams
            this.$store.dispatch('upSession', {gameOnTracking: updatedTracking})
          }
        }
      }
    },
    async endGame(isManual = false) {
      if (this.showGameOver) return
      this.showGameOver = true

      if (this.timerInterval) {
        clearInterval(this.timerInterval)
        this.timerInterval = null
      }

      // Patch game-on record status to 2 (ended) and await backend's generated analysis
      const recordId = this.gameConfig && this.gameConfig.gameOnRecord && this.gameConfig.gameOnRecord._id
      const currentStatus = this.gameConfig && this.gameConfig.gameOnRecord && this.gameConfig.gameOnRecord.status

      if (isManual && window.App && recordId && currentStatus !== 2) {
        try {
          const patchedRecord = await window.App.service('game-on').patch(recordId, {status: 2})
          if (patchedRecord) {
            this.gameStatus = patchedRecord.status || 2
            if (patchedRecord.analysis) {
              this.analysis = patchedRecord.analysis
            }
            if (this.gameConfig) {
              this.$set(this.gameConfig, 'gameOnRecord', patchedRecord)
              if (this.analysis) {
                this.$set(this.gameConfig, 'analysis', this.analysis)
              }
              this.$set(this.gameConfig, 'responses', this.responses)
            }
          }

          // Sync status to session for other teacher/projector views
          if (this.session && this.session.gameOnTracking) {
            const updatedTracking = JSON.parse(JSON.stringify(this.session.gameOnTracking))
            if (updatedTracking.gameConfig) {
              updatedTracking.gameConfig.gameOnRecord = patchedRecord || updatedTracking.gameConfig.gameOnRecord
              updatedTracking.gameConfig.gameOnRecord.status = 2
              updatedTracking.gameConfig.responses = this.responses
              if (this.analysis) {
                updatedTracking.gameConfig.analysis = this.analysis
              }
              this.$store.dispatch('upSession', {gameOnTracking: updatedTracking})
            }
          }
        } catch (err) {
          console.error('Failed to set game status=2:', err)
        }
      } else if (!isManual && window.App && recordId && this.gameStatus !== 2) {
        // Fallback if the patch wasn't executed instantly
        // this.gameStatus = 2
        if (this.gameConfig) {
          this.$set(this.gameConfig, 'responses', this.responses)
          if (this.analysis) {
            this.$set(this.gameConfig, 'analysis', this.analysis)
          }
        }
        
        // Sync status to session for other teacher/projector views during automatic end
        if (this.isDashboard && this.session && this.session.gameOnTracking) {
          const updatedTracking = JSON.parse(JSON.stringify(this.session.gameOnTracking))
          if (updatedTracking.gameConfig && updatedTracking.gameConfig.gameOnRecord) {
            // updatedTracking.gameConfig.gameOnRecord.status = 2
            updatedTracking.gameConfig.responses = this.responses
            if (this.analysis) {
              updatedTracking.gameConfig.analysis = this.analysis
            }
            updatedTracking.teams = this.liveTeams
          this.$store.dispatch('upSession', {gameOnTracking: updatedTracking})
        }
      }
    }
    this.showGameOver = true

      // Sync status to session for other teacher/projector views
      if (this.isDashboard && this.session && this.session.gameOnTracking) {
        const updatedTracking = JSON.parse(JSON.stringify(this.session.gameOnTracking))
        if (updatedTracking.gameConfig) {
          updatedTracking.gameConfig.showGameOver = true
          updatedTracking.gameConfig.gameStatus = this.gameStatus
          updatedTracking.gameConfig.responses = this.responses
          if (this.analysis) {
            updatedTracking.gameConfig.analysis = this.analysis
          }
          if (updatedTracking.gameConfig.gameOnRecord) {
            updatedTracking.gameConfig.gameOnRecord.status = this.gameStatus
          }
          this.$store.dispatch('upSession', {gameOnTracking: updatedTracking})
        }
      }

      if (window.App) {
        window.App.service('auth').patch('syncTeacher', {
          commit: 'student/endGameOn',
          data: true,
        })
        window.App.service('auth').patch('syncTeacher', {
          commit: 'student/setActiveMissionQuestions',
          data: null,
        })
      }
    },
    closeGameOver() {
      this.showGameOver = false
      this.$emit('end-game', this.gameConfig)
    },
    getFullQuestion(slide) {
      if (!slide) return null
      const pageId = slide.page || slide.id
      const questions = this.session && this.session.questions ? this.session.questions : []
      return questions.find((q) => q.page === pageId || q.id === pageId) || slide
    },
    isCpaQuestion(slide) {
      const fullQuestion = this.getFullQuestion(slide)
      return fullQuestion && fullQuestion.cpa && fullQuestion.cpa.outcome
    },
    getQuestionText(slide) {
      const fullQuestion = this.getFullQuestion(slide)
      if (!fullQuestion) return ''
      return fullQuestion.abstractData || fullQuestion.data || (fullQuestion.abstract && fullQuestion.abstract.data) || 'Question Data'
    },
    getSlideOptions(slide) {
      const fullQuestion = this.getFullQuestion(slide)
      if (!fullQuestion) return []
      return fullQuestion.options || null
    },
    optionText(opt) {
      return opt.val || opt.data || opt.text || opt
    },
    getPercentAttempted(slide) {
      let attemptedCount = 0
      let activeMembersCount = 0

      this.liveTeams.forEach((t) => {
        if (t.members) {
          activeMembersCount += t.members.length
          attemptedCount += t.members.reduce((acc, m) => {
            return acc + (m.lockedPages && m.lockedPages.includes(slide.pageId) ? 1 : 0)
          }, 0)
        }
      })
      if (activeMembersCount === 0) return 0
      return Math.round((attemptedCount / activeMembersCount) * 100)
    },
    getPercentCorrect(slide) {
      let correctHits = 0
      let activeMembersCount = 0

      this.liveTeams.forEach((t) => {
        if (t.members) {
          activeMembersCount += t.members.length
          correctHits += t.members.reduce((acc, m) => {
            return acc + (m.correctPages && m.correctPages.includes(slide.pageId) ? 1 : 0)
          }, 0)
        }
      })

      if (activeMembersCount === 0) return 0
      return Math.round((correctHits / activeMembersCount) * 100)
    },
    previewImage(picUrl) {
      if (picUrl) {
        this.previewPicUrl = picUrl
      }
    },
    previewCpa(slide) {
      if (slide) {
        const slideId = slide.page || slide.id
        if (this.activeTooltipSlideId === slideId) {
          this.activeTooltipSlideId = null
          this.previewCpaData = null
          return
        }
        const fullQuestion = this.getFullQuestion(slide)
        this.activeTooltipSlideId = slideId
        this.previewCpaData = {
          abstractData: fullQuestion && fullQuestion.abstract && fullQuestion.abstract.data ? fullQuestion.abstract.data : '',
          options: this.getSlideOptions(slide) || [],
        }
      }
    },
    toggleDashboardCard(idx) {
      this.$set(this.expandedDashboardCards, idx, !this.expandedDashboardCards[idx])
    },
    closePreview() {
      this.previewPicUrl = null
      this.activeTooltipSlideId = null
      this.previewCpaData = null
    },
   getCpaBloomStats(slide) {
      let attemptCount = 0
      let correctHits = 0
      let activeMembersCount = 0

      this.liveTeams.forEach((t) => {
        if (t.members) {
          t.members.forEach((m) => {
            activeMembersCount++
            const isAttempted = m.lockedPages && m.lockedPages.some(pageId => slide.page === pageId || slide.id === pageId || (this.getFullQuestion(slide) && (this.getFullQuestion(slide).page === pageId || this.getFullQuestion(slide).id === pageId || this.getFullQuestion(slide).page_id === pageId)))
               
            const isCorrect = m.correctPages && m.correctPages.some(pageId => slide.page === pageId || slide.id === pageId || (this.getFullQuestion(slide) && (this.getFullQuestion(slide).page === pageId || this.getFullQuestion(slide).id === pageId || this.getFullQuestion(slide).page_id === pageId)))
            
            if (isAttempted) {
              attemptCount++
            }
            if (isCorrect) {
              correctHits++
            }
          })
        }
      })

      const fullQuestion = this.getFullQuestion(slide)

      let wrongHits = attemptCount - correctHits
      let bloomValue = fullQuestion && fullQuestion.bloom && fullQuestion.bloom.length > 0 ? fullQuestion.bloom[0] : 4
      const BloomLabels = ['REMEMBER', 'UNDERSTAND', 'APPLY', 'ANALYZE', 'EVALUATE', 'CREATE']
      let levelName = BloomLabels[bloomValue - 1] || 'ANALYZE'
      let levelPrefix = `LEVEL ${bloomValue} : `

      return [
        {
          levelPrefix: levelPrefix,
          levelName: levelName,
          attempt: `${attemptCount}/${activeMembersCount}`,
          correct: `${correctHits}/${activeMembersCount}`,
          wrong: `${wrongHits}/${activeMembersCount}`,
        },
      ]
    },
    handleZoomClick() {
      const userName = this.user?.nickname || this.user?.name || ''
      const url = location.origin + '/livekit?name=' + encodeURIComponent(userName) + '&sid=' + this.session.sid
      this.$store.commit('setMeeting', {
        active: true,
        minimized: false,
        url: url,
        name: userName
      })
    },
   
  },
}
</script>

<style scoped>
.gt-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: #091315 url('https://r2.classcipe.com/bf9f3fd9c1be16c9c3aaa7491dc43fdf188435aa') no-repeat center center fixed;
  background-size: cover;
  color: #fff;
  font-family: Arial, sans-serif;
  z-index: 100000;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.gt-header {
  height: 50px;
  background: rgba(7, 25, 29, 0.6);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border-bottom: 2px solid #00ffff;
  display: flex;
  align-items: center;
  padding: 0 24px;
}
.gt-header-left {
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 2px;
  color: #fff;
  display: flex;
  align-items: center;
  gap: 8px;
}
.gt-header-left i {
  color: #00ffff;
  font-size: 18px;
}

.gt-main {
  flex: 1;
  display: flex;
  overflow: hidden;
}

/* LEFT PANEL */
.gt-left-panel {
  width: 340px;
  background: rgba(12, 22, 26, 0.5);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border-right: 1px solid rgba(255, 255, 255, 0.1);
  display: flex;
  flex-direction: column;
  padding: 24px;
  box-sizing: border-box;
}
.gt-timer-box {
  background: rgba(7, 18, 21, 0.5);
  border: 1px solid rgba(0, 255, 255, 0.2);
  border-radius: 8px;
  padding: 20px;
  text-align: center;
  margin-bottom: 30px;
  backdrop-filter: blur(5px);
}
.gt-timer-label {
  font-size: 10px;
  color: #00ffff;
  letter-spacing: 1px;
  margin-bottom: 10px;
  font-weight: bold;
}
.gt-dashboard-card-header {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.gt-view-btn {
  color: #00ffff;
  font-size: 11px;
  font-weight: bold;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
  background: transparent;
  transition: opacity 0.2s;
}
.gt-view-btn i {
  font-size: 16px;
}
.gt-view-btn:hover {
  opacity: 0.8;
}
.gt-cpa-question-text {
  color: #fff;
  font-size: 14px;
  line-height: 1.6;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  margin-bottom: 4px;
  min-height: 42px;
  padding: 0 4px;
}
.gs-cpa-close {
  position: absolute;
  top: 16px;
  right: 20px;
  color: #8c99a0;
  font-size: 20px;
  cursor: pointer;
  transition: color 0.2s;
  z-index: 10;
}
.gs-cpa-close:hover {
  color: #fff;
}
.gs-cpa-modal {
  background: #0d2729;
  border: 1px solid #00ffff;
  border-radius: 8px;
  padding: 32px;
  font-size: 16px;
  color: #fff;
  width: 90%;
  max-width: 600px;
  max-height: 80vh;
  overflow-y: auto;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.8);
  font-family: Arial, sans-serif;
  position: relative;
}
.gs-cpa-question {
  margin-bottom: 12px;
  line-height: 1.4;
  padding-right: 24px;
}
.gs-cpa-options {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.gs-cpa-option {
  display: flex;
  align-items: flex-start;
  line-height: 1.4;
}
.gs-cpa-tick {
  color: #00e676;
  margin-right: 8px;
  margin-top: 3px;
  font-size: 12px;
  width: 14px;
}
.gs-cpa-indent {
  margin-left: 22px;
}
.gs-preview-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.85);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 100000;
}
.gs-preview-image {
  max-width: 90vw;
  max-height: 90vh;
  object-fit: contain;
  border-radius: 8px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.8);
  border: 1px solid #1a3c40;
}
.gs-preview-close {
  position: absolute;
  top: 30px;
  right: 30px;
  color: #8c99a0;
  font-size: 32px;
  cursor: pointer;
  transition: color 0.2s;
  z-index: 100001;
}
.gs-preview-close:hover {
  color: #fff;
}
.gs-cpa-tooltip {
  position: absolute;
  top: 100%;
  width: 320px;
  background: #0d2729;
  border: 1px solid #00ffff;
  border-radius: 8px;
  padding: 16px;
  z-index: 10000;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.8);
  font-family: Arial, sans-serif;
  color: #fff;
  cursor: default;
  margin-top: 8px;
}
.gs-cpa-tooltip-left {
  left: 0;
}
.gs-cpa-tooltip-right {
  right: 0;
}
.gs-cpa-tooltip-question {
  margin-bottom: 12px;
  line-height: 1.4;
  font-size: 13px;
}
.gs-cpa-tooltip-options {
  display: flex;
  flex-direction: column;
  gap: 8px;
  font-size: 13px;
}
.gs-cpa-tooltip-option {
  display: flex;
  align-items: flex-start;
  line-height: 1.4;
}
.gs-cpa-tooltip-tick {
  color: #00e676;
  margin-right: 8px;
  margin-top: 3px;
  font-size: 12px;
  width: 14px;
}
.gs-cpa-tooltip-indent {
  margin-left: 22px;
}
.gt-bloom-table-container {
  flex: 1;
  overflow-y: auto;
  margin-top: 8px;
  min-height: 0;
  padding-right: 4px;
}
.gt-bloom-table-container::-webkit-scrollbar {
  width: 4px;
}
.gt-bloom-table-container::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 2px;
}
.gt-bloom-table {
  width: 100%;
}
.gt-bloom-header {
  display: flex;
  padding-bottom: 8px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.15);
  margin-bottom: 8px;
  text-transform: uppercase;
}
.gt-bloom-header > div {
  font-size: 10px !important;
  color: #e2e8f0;
  font-weight: bold;
  letter-spacing: 1.5px;
}
.gt-bloom-rows {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.gt-bloom-row {
  display: flex;
  align-items: center;
  background: rgba(12, 12, 12, 0.6);
  border: 1px solid rgba(255, 255, 255, 0.05);
  padding: 12px;
  border-radius: 6px;
}
.gt-timer-value {
  font-size: 48px;
  color: #00ffff;
  font-weight: bold;
  text-shadow: 0 0 15px rgba(0, 255, 255, 0.6);
  margin-bottom: 10px;
  line-height: 1;
}
.gt-timer-bar-container {
  width: 100%;
  height: 4px;
  background: #1a3c40;
  border-radius: 2px;
  overflow: hidden;
}
.gt-timer-bar {
  height: 100%;
  background: #00ffff;
  box-shadow: 0 0 10px #00ffff;
  transition: width 1s linear;
}

.gt-section-title {
  font-size: 10px;
  color: #00ffff;
  letter-spacing: 1px;
  font-weight: bold;
  margin-bottom: 16px;
  text-transform: uppercase;
}

.gt-leaderboard {
  flex: 1;
  overflow-y: auto;
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.gt-lb-card {
  display: flex;
  align-items: center;
  background: rgba(18, 30, 36, 0.4);
  backdrop-filter: blur(4px);
  border: 1px solid rgba(255, 255, 255, 0.05);
  border-left: 4px solid;
  border-radius: 6px;
  padding: 12px 16px;
}
.gt-lb-rank {
  font-size: 20px;
  font-weight: bold;
  width: 30px;
}
.gt-lb-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.gt-lb-name {
  font-size: 12px;
  font-weight: bold;
  text-transform: uppercase;
}
.gt-lb-avatars {
  display: flex;
  margin-left: 6px;
}
.gt-avatar {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  font-size: 7px;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #091315;
  margin-left: -6px;
  font-weight: bold;
}
.gt-avatar:first-child {
  margin-left: 0;
}
.gt-lb-score {
  text-align: right;
}
.gt-lb-points {
  font-size: 20px;
  font-weight: bold;
}
.gt-lb-points-label {
  font-size: 8px;
  color: #8c99a0;
  letter-spacing: 1px;
}

.gt-recent-activity {
  background: rgba(18, 30, 36, 0.5);
  backdrop-filter: blur(8px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 20px;
}

.gt-btn-end {
  width: 100%;
  background: #ff00ff;
  color: #fff;
  border: none;
  padding: 16px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: bold;
  letter-spacing: 1px;
  cursor: pointer;
  transition: 0.2s;
  box-shadow: 0 0 15px rgba(255, 0, 255, 0.4);
}
.gt-btn-end:hover {
  background: #e600e6;
  box-shadow: 0 0 20px rgba(255, 0, 255, 0.6);
}

/* CENTER PANEL */
.gt-center-panel {
  flex: 1;
  position: relative;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  padding: 0 40px;
  box-sizing: border-box;
  background: transparent;
  z-index: 5;
}

/* DASHBOARD SLIDE VIEWER — override the flex alignment */
.gt-center-slides {
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  padding: 0;
  margin-top: 15px;
  z-index: 10;
  overflow-y: auto;
}

/* Progress tabs bar */
.gt-slides-progress {
  display: flex;
  background: rgba(7, 25, 29, 0.4);
  backdrop-filter: blur(10px);
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  overflow-x: auto;
  flex-shrink: 0;
}
.gt-slide-tab {
  flex: 1;
  min-width: 80px;
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  padding: 10px 8px 8px;
  transition: background 0.2s;
  position: relative;
}
.gt-slide-tab:hover {
  background: #0d2525;
}
.gt-slide-tab-bar {
  width: 100%;
  height: 3px;
  background: #1a3c40;
  border-radius: 2px;
  margin-bottom: 6px;
  transition: background 0.25s;
}
.gt-slide-tab.active .gt-slide-tab-bar {
  background: #00ffff;
  box-shadow: 0 0 8px rgba(0, 255, 255, 0.7);
}
.gt-slide-tab-label {
  font-size: 10px;
  color: #8c99a0;
  letter-spacing: 0.5px;
  font-weight: bold;
  white-space: nowrap;
}
.gt-slide-tab.active .gt-slide-tab-label {
  color: #00ffff;
}

/* Navigation row */
.gt-slide-nav-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 24px;
  background: rgba(9, 19, 21, 0.4);
  backdrop-filter: blur(8px);
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  flex-shrink: 0;
}
.gt-slide-nav-btn {
  background: transparent;
  border: none;
  color: #8c99a0;
  font-size: 11px;
  font-weight: bold;
  letter-spacing: 1px;
  cursor: pointer;
  padding: 6px 12px;
  border-radius: 4px;
  transition: color 0.2s, background 0.2s;
}
.gt-slide-nav-btn:hover:not(:disabled) {
  color: #00ffff;
  background: #0d2525;
}
.gt-slide-nav-btn:disabled {
  opacity: 0.3;
  cursor: default;
}
.gt-slide-question-title {
  font-size: 16px;
  font-weight: bold;
  color: #00ffff;
  letter-spacing: 2px;
  text-shadow: 0 0 10px rgba(0, 255, 255, 0.4);
}
.gt-btn-analyse {
  background: transparent;
  border: 1px solid #00ffff;
  color: #00ffff;
  padding: 4px 12px;
  border-radius: 4px;
  font-size: 10px;
  font-weight: bold;
  letter-spacing: 1px;
  cursor: pointer;
  transition: all 0.2s;
}
.gt-btn-analyse:hover {
  background: rgba(0, 255, 255, 0.1);
  box-shadow: 0 0 10px rgba(0, 255, 255, 0.2);
}

/* Slide image area */
.gt-slide-preview-area {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  overflow: hidden;
}
.gt-slide-image {
  width: 100%;
  height: 100%;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  border-radius: 8px;
}
.gt-slide-no-image {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background: #0c161a;
  border: 1px dashed #1a3c40;
  border-radius: 8px;
}

.gt-race-track {
  width: 100%;
  height: 80%;
  display: flex;
  justify-content: space-around;
  position: relative;
}
.gt-rocket-lane {
  position: relative;
  width: 60px;
  height: 100%;
  display: flex;
  justify-content: center;
}
.gt-rocket-wrapper {
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  transition: bottom 1s cubic-bezier(0.25, 0.8, 0.25, 1);
}

@keyframes rocketVibrate {
  0% {
    transform: translateX(0);
  }
  15% {
    transform: translateX(-3px) rotate(-1deg);
  }
  30% {
    transform: translateX(3px) rotate(1deg);
  }
  45% {
    transform: translateX(-2px) rotate(-0.5deg);
  }
  60% {
    transform: translateX(2px) rotate(0.5deg);
  }
  75% {
    transform: translateX(-1px);
  }
  100% {
    transform: translateX(0);
  }
}

.rocket-moving {
  animation: rocketVibrate 0.15s ease-in-out infinite;
}
.gt-rocket-label {
  border: 1px solid;
  border-radius: 4px;
  padding: 4px 8px;
  font-size: 10px;
  font-weight: bold;
  background: rgba(9, 19, 21, 0.6);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  margin-bottom: 12px;
  white-space: nowrap;
}
.gt-rocket-icon {
  position: relative;
  z-index: 2;
  display: flex;
  justify-content: center;
}
.gt-rocket-tail {
  position: absolute;
  top: 90%;
  left: 50%;
  transform: translateX(-50%);
  width: 6px;
  height: 200px;
  border-radius: 3px;
  z-index: 1;
  filter: blur(2px);
  opacity: 0.8;
  transition: all 1.5s cubic-bezier(0.25, 0.8, 0.25, 1);
}

.rocket-finished .rocket-svg {
  width: 140px;
  transform: translateY(-20px);
  filter: drop-shadow(0 0 25px currentColor);
}
.rocket-finished .gt-rocket-tail {
  width: 14px;
  height: 400px;
  filter: blur(4px);
  opacity: 1;
}

/* RIGHT PANEL */
.gt-right-panel {
  width: 360px;
  background: rgba(12, 21, 24, 0.5);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border-left: 1px solid rgba(255, 255, 255, 0.1);
  display: flex;
  flex-direction: column;
  padding: 24px;
  box-sizing: border-box;
}
.gt-log-header {
  font-size: 14px;
  color: #fff;
  font-weight: bold;
  letter-spacing: 2px;
  margin-bottom: 24px;
  display: flex;
  align-items: center;
  gap: 10px;
}
.gt-log-list {
  flex: 1;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.gt-log-item {
  background: rgba(18, 30, 36, 0.3);
  backdrop-filter: blur(4px);
  border: 1px solid rgba(255, 255, 255, 0.05);
  border-radius: 6px;
  padding: 10px 12px;
  font-size: 9px;
  display: flex;
  align-items: center;
  line-height: 1.4;
  color: #c9d1d6;
}
.gt-log-processing {
  font-size: 9px;
  color: #8c99a0;
  margin-top: 10px;
  font-style: italic;
}

/* DASHBOARD GRID & CARDS */
.gt-dashboard-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  width: 100%;
  padding: 20px;
  box-sizing: border-box;
  align-content: flex-start;
}
.gt-dashboard-card {
  background: rgba(15, 28, 33, 0.45);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  height: 350px;
}
.gt-dashboard-card-header {
  padding: 14px 16px;
  background: rgba(5, 14, 18, 0.95);
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.gt-dashboard-card-footer {
  padding: 14px 16px;
  border-top: 1px solid rgba(255, 255, 255, 0.05);
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: rgba(5, 14, 18, 0.95);
}

.gt-rocket-avatar {
  position: absolute;
  top: 90px;
  left: 50%;
  transform: translateX(-50%);
  width: 22px;
  height: 22px;
  border-radius: 50%;
  border: 2px solid;
  background: rgba(9, 19, 21, 0.6);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 9px;
  font-weight: bold;
  color: #fff;
  z-index: 4;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
  animation: popIn 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}
.gt-rocket-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
}
.gt-avatar-tooltip {
  position: absolute;
  bottom: -22px;
  left: 50%;
  transform: translateX(-50%);
  background: rgba(9, 19, 21, 0.9);
  border: 1px solid;
  border-radius: 4px;
  padding: 4px 6px;
  font-size: 12px;
  white-space: nowrap;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.2s;
  pointer-events: none;
  z-index: 5;
}
.gt-rocket-avatar:hover .gt-avatar-tooltip {
  opacity: 1;
  visibility: visible;
}

.rocket-svg {
  width: 80px;
  height: auto;
  display: block;
  will-change: transform, width, filter;
  filter: drop-shadow(0 0 10px currentColor);
  transition: all 1.5s cubic-bezier(0.25, 0.8, 0.25, 1);
}

.gt-rocket-wrapper:not(.rocket-moving) .rocket-svg {
  animation: idle-thrum 3s ease-in-out infinite;
}

@keyframes idle-thrum {
  0%,
  100% {
    transform: translate(0, 0);
  }
  50% {
    transform: translate(0, -6px);
  }
}

@keyframes popIn {
  0% {
    transform: translateX(-50%) scale(0);
    opacity: 0;
  }
  100% {
    transform: translateX(-50%) scale(1);
    opacity: 1;
  }
}

/* Scrollbar */
::-webkit-scrollbar {
  width: 6px;
}
::-webkit-scrollbar-track {
  background: transparent;
}
::-webkit-scrollbar-thumb {
  background: #1a3c40;
  border-radius: 3px;
}
::-webkit-scrollbar-thumb:hover {
  background: #33ffff;
}

.gt-score-popup {
  position: absolute;
  top: -30px;
  left: 50%;
  transform: translateX(-50%);
  color: #00ffff;
  font-weight: bold;
  font-size: 24px;
  text-shadow: 0 0 10px rgba(0, 255, 255, 0.8), 0 0 20px rgba(0, 255, 255, 0.4);
  animation: scoreFloatUp 2s forwards;
  pointer-events: none;
  z-index: 10;
}

@keyframes scoreFloatUp {
  0% {
    transform: translate(-50%, 0);
    opacity: 0;
  }
  20% {
    transform: translate(-50%, -20px);
    opacity: 1;
  }
  80% {
    transform: translate(-50%, -40px);
    opacity: 1;
  }
  100% {
    transform: translate(-50%, -60px);
    opacity: 0;
  }
}

/* Mobile-only race section — hidden on desktop */
.gt-mobile-race {
  display: none;
}

/* Projector Tabs - hidden on desktop */
.gt-projector-tabs {
  display: none;
}

/* Mobile-only end game button — hidden on desktop */
.gt-mobile-end-btn {
  display: none;
}

/* ===== MOBILE RESPONSIVE ===== */
@media (max-width: 1024px) {
  .gt-overlay {
    overflow: hidden;
  }

  .gt-header {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 1000;
    height: 44px;
    padding: 0 16px;
  }

  .gt-main {
    flex-direction: column;
    overflow: hidden;
    position: absolute;
    top: 44px;
    left: 0;
    right: 0;
    bottom: 84px; /* Space for END GAME button */
    height: auto;
    margin: 0;
  }

  /* LEFT PANEL: becomes the scrollable content area on mobile */
  .gt-left-panel {
    width: 100%;
    border-right: none;
    padding: 16px;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    flex: 1;
    min-height: 0;
    order: 1;
    backdrop-filter: none;
    -webkit-backdrop-filter: none;
    background: transparent;
  }

  .gt-timer-box {
    margin-bottom: 8px;
    padding: 16px;
    display: grid;
    grid-template-areas:
      'label value'
      'bar  bar';
    grid-template-columns: 1fr auto;
    align-items: center;
  }

  .gt-timer-label {
    grid-area: label;
    text-align: left;
    margin-bottom: 0;
  }

  .gt-timer-value {
    grid-area: value;
    font-size: 28px;
    margin-bottom: 0;
    text-align: right;
  }

  .gt-timer-bar-container {
    grid-area: bar;
    margin-top: 14px;
  }

  /* CENTER PANEL: sits inside the scroll flow on mobile (above leaderboard) */
  .gt-center-panel {
    order: 0;
    width: 100%;
    flex: none;
    padding: 0;
    height: auto;
    min-height: 0;
    position: static;
  }

  /* Hide desktop center panel rockets on mobile (mobile-only version in left panel) */
  .gt-center-panel:not(.gt-center-slides) {
    display: none;
  }

  .gt-section-title {
    margin-bottom: 12px;
    text-align: center;
  }

  /* Projector Tabs - visible on mobile */
  .gt-projector-tabs {
    display: flex;
    margin-bottom: 24px;
    border-bottom: 2px solid rgba(255, 255, 255, 0.1);
  }
  .gt-pt-tab {
    flex: 1;
    text-align: center;
    padding: 10px 0;
    font-size: 14px;
    color: #8c99a0;
    cursor: pointer;
    font-weight: 500;
  }
  .gt-pt-tab.active {
    color: #00ffff;
    border-bottom: 2px solid #00ffff;
    margin-bottom: -2px; /* to overlap the parent border */
  }

  .gt-hide-on-mobile {
    display: none !important;
  }

  /* Mobile-only race section */
  .gt-mobile-race {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
  }

  .gt-mobile-race-labels {
    display: none;
  }

  .gt-mobile-race-label {
    text-align: center;
    width: 50px;
  }

  .gt-mobile-race-name {
    font-size: 9px;
    font-weight: bold;
    letter-spacing: 0.5px;
    text-transform: uppercase;
    margin-bottom: 2px;
  }

  .gt-mobile-race-pct {
    display: none;
  }

  /* RACE TRACK: vertical rockets for mobile */
  .gt-mobile-race-track {
    width: 100%;
    flex: 1;
    display: flex;
    justify-content: space-around;
    align-items: flex-end;
    padding: 0 10px;
    box-sizing: border-box;
  }

  .gt-mobile-race-track .gt-rocket-lane {
    width: 75px;
    height: 100%;
  }

  .gt-mobile-race-track .rocket-svg {
    width: 65px;
  }

  .gt-mobile-race-track .gt-rocket-tail {
    height: 120px;
    width: 4px;
  }

  .gt-mobile-race-track .rocket-finished .rocket-svg {
    width: 80px;
    transform: translateY(-10px);
  }

  .gt-mobile-race-track .rocket-finished .gt-rocket-tail {
    width: 8px;
    height: 180px;
  }

  /* LEADERBOARD: full width cards, no own scroll */
  .gt-leaderboard {
    flex: none;
    overflow-y: visible;
    gap: 8px;
    margin-bottom: 16px;
  }

  .gt-lb-card {
    padding: 10px 12px;
  }

  .gt-lb-rank {
    font-size: 16px;
    width: 26px;
  }

  .gt-lb-name {
    font-size: 11px;
  }

  .gt-lb-points {
    font-size: 18px;
  }

  /* Hide original END GAME button on mobile (replaced by gt-mobile-end-btn) */
  .gt-btn-end {
    display: none;
  }

  /* Mobile END GAME button: fixed at bottom, outside scrollable area */
  .gt-mobile-end-btn {
    display: block;
    position: fixed;
    bottom: 10px;
    left: 12px;
    right: 12px;
    z-index: 100001;
    width: calc(100vw - 24px);
    margin: 0;
    background: #ff00ff;
    color: #fff;
    border: none;
    padding: 14px 0;
    border-radius: 8px;
    font-size: 13px;
    font-weight: bold;
    letter-spacing: 1px;
    cursor: pointer;
    box-shadow: 0 0 15px rgba(255, 0, 255, 0.4);
    box-sizing: border-box;
    -webkit-appearance: none;
    appearance: none;
  }

  /* RECENT ACTIVITY */
  .gt-recent-activity {
    margin-bottom: 16px;
  }

  /* RIGHT PANEL: hide on mobile */
  .gt-right-panel {
    display: none;
  }

  /* DASHBOARD: cards in single column */
  .gt-dashboard-grid {
    grid-template-columns: 1fr;
    padding: 10px;
    gap: 12px;
  }

  .gt-dashboard-card {
    height: 155px;
    min-height: 155px;
    position: relative;
    padding-bottom: 56px;
    overflow: hidden;
  }
  .gt-dashboard-card.gt-mobile-expanded {
    height: auto;
  }

  .gt-dashboard-card-body {
    gap: 4px !important;
  }

  .gt-dashboard-card-body > * {
    flex-shrink: 0;
  }

  .gt-cpa-question-text {
    min-height: auto;
    margin-bottom: 0;
    font-size: 14px !important;
  }

  .gt-dashboard-card-footer {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    z-index: 2;
    box-sizing: border-box;
  }

  /* Score popup */
  .gt-score-popup {
    font-size: 18px;
  }

  /* Dashboard mobile specific tabs */
  .gt-dashboard-tabs {
    display: flex;
    justify-content: space-between;
  }
  .gt-dashboard-tabs .gt-pt-tab {
    font-size: 11px;
    padding: 8px 0;
  }

  /* Structural overrides for mobile dashboard */
  .gt-mobile-dashboard {
    position: absolute !important;
    top: 44px !important;
    bottom: 84px !important;
    left: 0 !important;
    right: 0 !important;
    height: auto !important;
    overflow-y: auto !important;
    -webkit-overflow-scrolling: touch;
    overscroll-behavior-y: contain;
    background: transparent !important;
  }
  .gt-mobile-dashboard .gt-left-panel {
    flex: none;
    overflow-y: visible;
    padding-bottom: 20px;
    min-height: auto;
  }
  .gt-mobile-dashboard .gt-center-panel {
    order: 2;
    flex: none !important;
    padding-bottom: 20px;
  }
  .gt-center-panel > div {
    height: auto !important;
    overflow-y: visible !important;
  }

  .gt-show-on-mobile-flex {
    display: flex !important;
  }

  .gt-right-panel.gt-show-on-mobile-flex {
    order: 3;
    width: 100%;
    padding: 16px;
    padding-bottom: 80px;
    border: none;
    flex: none;
    min-height: 0;
    backdrop-filter: none;
    -webkit-backdrop-filter: none;
    background: transparent;
  }
  .gt-log-list {
    overflow-y: visible;
  }
  .gt-log-item {
    backdrop-filter: none !important;
    -webkit-backdrop-filter: none !important;
    background: rgba(18, 30, 36, 0.95);
  }

  .gt-mobile-collapse {
    display: none !important;
  }
}
</style>
